import PolicyLayout from "./PolicyLayout";

export default function ShippingPage() {
  return (
    <PolicyLayout
      title="Shipping & Delivery Policy"
      updated="December 2025"
      testId="shipping-page"
    >
      <p>
        Every Me Amor box is packed with care in New Zealand and dispatched
        via a tracked courier service. This policy outlines where we ship,
        our delivery timelines and how to track your order.
      </p>

      <h2>1. Where we ship</h2>
      <p>
        We currently ship to <strong>all New Zealand addresses</strong>{" "}
        (rural addresses included). International orders are not yet
        available — join the Pen Pal Club to be notified when we expand.
      </p>

      <h2>2. Shipping fees</h2>
      <p>
        Shipping is a flat rate based on your delivery zone within New Zealand,
        added at checkout per order:
      </p>
      <ul>
        <li>
          <strong>Urban NZ:</strong> NZ$8.99
        </li>
        <li>
          <strong>Rural NZ:</strong> NZ$14.99
        </li>
        <li>
          <strong>Small collectables NZ-wide:</strong> NZ$3.00 flat, when your
          order contains only limited-edition collectable items (e.g. Butterfly
          Collection or Christmas Stocking Stuffer).
        </li>
      </ul>
      <p>
        You&apos;ll choose your zone in the basket. If you&apos;re unsure
        whether your address is urban or rural, our courier will confirm and
        we&apos;ll be in touch if there&apos;s any adjustment to make.
      </p>

      <h2>3. Dispatch timelines</h2>
      <ul>
        <li>
          <strong>One-off boxes</strong> (Activity Kit, Birthday Kit): packed
          and dispatched within <strong>2–4 business days</strong> of order
          confirmation.
        </li>
        <li>
          <strong>Personalised Birthday Kits</strong>: dispatched within{" "}
          <strong>4–6 business days</strong> to allow time for
          personalisation.
        </li>
        <li>
          <strong>Seasonal Subscription Boxes</strong> ship in the first
          two weeks of each new season (Spring, Summer, Autumn, Winter).
          You&apos;ll receive an email when your box is on the way.
        </li>
      </ul>

      <h2>4. Estimated delivery times (after dispatch)</h2>
      <ul>
        <li>
          <strong>Urban NZ:</strong> 2–3 business days
        </li>
        <li>
          <strong>Rural NZ:</strong> 3–5 business days
        </li>
      </ul>
      <p>
        These are indicative timelines provided by our courier partner and
        may be affected by public holidays, weather events, or courier
        delays outside our control.
      </p>

      <h2>5. Tracking</h2>
      <p>
        You&apos;ll receive an email with your courier tracking number once
        your box has been dispatched. If you don&apos;t receive a tracking
        email within our stated dispatch window, please contact us at{" "}
        <a href="mailto:empower.meamor@gmail.com">
          empower.meamor@gmail.com
        </a>
        .
      </p>

      <h2>6. Incorrect addresses</h2>
      <p>
        Please double-check your shipping address at checkout. If a parcel
        is returned to us because the address was incorrect, we can resend
        it — however you will be charged an additional shipping fee.
      </p>

      <h2>7. Missing or lost parcels</h2>
      <p>
        If your parcel is marked as delivered but you have not received it,
        please first check with neighbours, family members and any safe
        drop-off locations. If it is still missing after 3 business days,
        email us and we&apos;ll open an investigation with the courier and
        arrange a replacement or refund in accordance with our{" "}
        <a href="/refunds">Refund Policy</a>.
      </p>

      <h2>8. Public / school holidays</h2>
      <p>
        Dispatch timelines may be extended by 2–3 business days around New
        Zealand public holidays and during our end-of-year break (usually
        24 December – 5 January). We&apos;ll always announce closure dates
        on our website and to Pen Pal Club members.
      </p>

      <h2>9. Contact</h2>
      <p>
        Delivery question or issue? Email us anytime at{" "}
        <a href="mailto:empower.meamor@gmail.com">
          empower.meamor@gmail.com
        </a>
        .
      </p>
    </PolicyLayout>
  );
}
